import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../Shared/Services/shared.service';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class BuySellOrderService {
  readonly APIurl = environment.apiUrl;
  constructor(private http: HttpClient, private shared: SharedService) { }

  GetAll() {
    return this.http.get(`${this.APIurl}/SellBuyItems`, this.shared.options);
  }
  Get(id: number) {
    return this.http.get(`${this.APIurl}/SellBuyItems/${id}`, this.shared.options);
  }
  GetAllItems() {
    return this.http.get(`${this.APIurl}/Product/GetAllItems`, this.shared.options);
  }

  GetAllSuppliers() {
    return this.http.get(`${this.APIurl}/Agent/GetSuppliersByUserLogin`, this.shared.options);
  }

  GetAllClients() {
    return this.http.get(`${this.APIurl}/Client/GetAllAgentClients`, this.shared.options);
  }

  GetAllColors() {
    return this.http.get(`${this.APIurl}/Colors/GetAllColors`, this.shared.options);
  }

  GetAllSectors() {
    return this.http.get(`${this.APIurl}/Product/GetAllSectors`, this.shared.options);
  }

  GetAllAccessories() {
    return this.http.get(`${this.APIurl}/Product/GetAllAccessories`, this.shared.options);
  }

  InsertBuyOrder(data: any) {
    return this.http.post(`${this.APIurl}/SellBuyItems/InsertBuyOrder`, data, this.shared.options);
  }

  InsertSellOrder(data: any) {
    return this.http.post(`${this.APIurl}/SellBuyItems/InsertSellOrder`, data, this.shared.options);
  }

  SubmitUpload(data: any) {
    return this.http.post(`${this.APIurl}/SellBuyItems/SubmitUpload`, data, this.shared.options);
  }

  DownLoadPdf(data: any) {
    return this.http.post(`${this.APIurl}/SellBuyItems/DownLoadPdf`, data, this.shared.GetOptionsForDownLoad());
  }
}
